import React from "react";
import { Link } from "react-router-dom";
import { Clock, ChevronRight } from "lucide-react";
import { BranchAvatar } from "./BranchAvatar";
import { StatusPill, PriorityPill, MethodBadge, PlatformIcon, FormatTag } from "./Pills";

export default function QueueRow({ task }) {
  return (
    <Link to={`/ops/task/${task.id}`} data-testid={`queue-row-${task.id}`}
      className="grid grid-cols-12 items-center gap-3 px-4 py-3.5 hover:bg-[#F3F5EF] transition-colors group">
      <div className="col-span-12 sm:col-span-4 flex items-center gap-3 min-w-0">
        <BranchAvatar initials={task.branch_initials} color={task.branch_color} size={40} />
        <div className="min-w-0">
          <div className="font-semibold text-ink text-sm truncate">{task.branch_name} <span className="text-ink-3 font-normal">· {task.group_name}</span></div>
          <div className="text-xs text-ink-3 flex items-center gap-1.5"><PlatformIcon platform={task.platform} size={12} /> {task.handle}</div>
        </div>
      </div>

      <div className="col-span-6 sm:col-span-4 min-w-0">
        <div className="flex items-center gap-2">
          <FormatTag format={task.format} />
          <span className="text-ink-3">·</span>
          <span className="text-sm font-medium text-ink truncate">{task.reason}</span>
        </div>
        <div className="text-xs text-ink-2 truncate mt-0.5">{task.property?.address} · {task.property?.price}</div>
      </div>

      <div className="col-span-3 sm:col-span-1 flex items-center gap-1.5 text-xs font-semibold" style={{ color: task.overdue ? "#D0526B" : "#6B6E62" }}>
        <Clock size={13} strokeWidth={1.75} /> {task.recommended_time}
      </div>

      <div className="col-span-3 sm:col-span-3 flex items-center justify-end gap-2 flex-wrap">
        <PriorityPill priority={task.priority} />
        <MethodBadge method={task.method} />
        <StatusPill status={task.status} />
        <ChevronRight size={16} className="text-ink-3 hidden sm:block group-hover:translate-x-0.5 transition-transform" />
      </div>
    </Link>
  );
}
